import React from 'react'
import './Message.css'

function Message({message,time,user,userImage}) {
    return (
        <div className="message">
              <img src={userImage} alt=""/>
              <div className="message__info">
                    <h4>{user} <span className="message__date">{new Date(time?.toDate()).toUTCString()}</span></h4>
                    <p>{message}</p>
              </div>
        </div>
    )
}

export default Message
